import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material'
import type { FC } from 'react'
import { useRef } from 'react'
import type { UseFormSetValue } from 'react-hook-form'
import { useUploadLabelImage } from 'src/features/labelMaster/edit/LabelSamples/useUploadLabelImage'
import { LabelFormValues } from '../LabelFormContext/useLabelForm'

type Props = {
  setValue: UseFormSetValue<LabelFormValues>
}

/**
 * ラベルの画像を再アップロードする
 */
export const ReUploadButton: FC<Props> = ({ setValue }) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const { uploadLabelImage, isUploading } = useUploadLabelImage()

  const handleUpload = async () => {
    const file = fileInputRef.current?.files?.[0]
    if (!file) return

    const path = crypto.randomUUID()
    const result = await uploadLabelImage(file, path)
    if (!result) return

    setValue('imageUrl', result.imageUrl)
    setValue('imageId', result.id)
  }

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="medium"
        onClick={() => fileInputRef.current?.click()}
        sx={{ width: 'fit-content' }}
      >
        写真を変更
        <input
          type="file"
          hidden
          ref={fileInputRef}
          onChange={handleUpload}
          accept="image/*"
        />
      </Button>
      <Backdrop
        sx={{
          color: theme => theme.palette.common.white,
          zIndex: theme => theme.zIndex.drawer + 1,
          display: 'flex',
          flexDirection: 'column',
        }}
        open={isUploading}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 2,
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <CircularProgress color="primary" />
          <Typography variant="body1" color="text.primary">
            画像をアップロード中...
          </Typography>
        </Box>
      </Backdrop>
    </>
  )
}
